import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CameraControlsService {

  public readonly ACTION_CAMERA_DEFAULT_POSITION: string = 'defaultPosition';

  private cameraControlsActionSubject: Subject<string> = new Subject<string>();
  public get cameraControlsAction$(): Observable<string> {
    return this.cameraControlsActionSubject.asObservable();
  }

  public requestDefaultPosition(): void {
    this.cameraControlsActionSubject.next(this.ACTION_CAMERA_DEFAULT_POSITION);
  }
}
